// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button_KRK9X {
  background: #eeeeee;
  border : 1px solid #d2d2d2;
  border-radius : 2px;
}

.button_KRK9X > * {
  pointer-events: none;
}

.button_KRK9X:hover, .button_KRK9X:active, .button_KRK9X:focus { 
  outline:none;
}

.button_KRK9X:focus {
  border-color : rgba(75, 130, 252, 1.0);
}

.button_KRK9X:hover {
  background: #cccccc;
}

.button-link_rH815 {
  background: transparent;
  border : none;
}

.button-link_rH815:hover { 
  background: rgba( 255, 255, 255, 0.5 );
}


.button_KRK9X.button-linkSmall_FSdFS {
  font-size: 12px;
  background: transparent;
  border : none;
}

.button_KRK9X.button-linkSmall_FSdFS:hover { 
  background: rgba( 255, 255, 255, 0.5 );
}

.button-small_czxux {
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/theme/Button.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;;AAGA;EACE,eAAe;EACf,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".button {\n  background: #eeeeee;\n  border : 1px solid #d2d2d2;\n  border-radius : 2px;\n}\n\n.button > * {\n  pointer-events: none;\n}\n\n.button:hover, .button:active, .button:focus { \n  outline:none;\n}\n\n.button:focus {\n  border-color : rgba(75, 130, 252, 1.0);\n}\n\n.button:hover {\n  background: #cccccc;\n}\n\n.button-link {\n  background: transparent;\n  border : none;\n}\n\n.button-link:hover { \n  background: rgba( 255, 255, 255, 0.5 );\n}\n\n\n.button.button-linkSmall {\n  font-size: 12px;\n  background: transparent;\n  border : none;\n}\n\n.button.button-linkSmall:hover { \n  background: rgba( 255, 255, 255, 0.5 );\n}\n\n.button-small {\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `button_KRK9X`,
	"button-link": `button-link_rH815`,
	"button-linkSmall": `button-linkSmall_FSdFS`,
	"button-small": `button-small_czxux`
};
export default ___CSS_LOADER_EXPORT___;
